import { ROUTER } from '@core/constants/router.constants';
import { PrivateRoute } from '@router/private-route';
import { RouteObject } from 'react-router-dom';

import { MainLayout } from './main.layout';
import HomePage from './pages/home';
import { UserProfilePage } from './pages/user-profile';

export const mainRouter: RouteObject = {
  path: ROUTER.MAIN.INDEX,
  Component: MainLayout,
  children: [
    { index: true, element: <PrivateRoute element={<HomePage />} /> },
    { path: ROUTER.MAIN.PROFILE, element: <PrivateRoute element={<UserProfilePage />} /> },
  ],
};
